export const OPEN_FILE_VIEWER = "OPEN_FILE_VIEWER";
export const CLOSE_FILE_VIEWER = "CLOSE_FILE_VIEWER";
